import React from 'react';
import { BookOpenIcon, GiftIcon, ListChecksIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { images } from '../data/content';
export function Hero() {
  return <header className="relative overflow-hidden bg-cream px-4 pb-14 pt-6 sm:pb-20 sm:pt-10" data-id="element-176" data-mp="9lbgj25n3de4">
      <div className="mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-177" data-mp="4n1ov1j4iux9">
        <div className="flex items-center gap-2.5" data-id="element-178" data-mp="128fqzmni4jxa">
          <span className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-gold bg-navy font-serif text-sm font-bold text-gold-light" data-id="element-179" data-mp="1274mtlq59a5n">
            NB
          </span>
          <div className="text-left leading-tight" data-id="element-180" data-mp="sde1gppbdfu6">
            <p className="font-serif text-base font-bold text-navy sm:text-lg" data-id="element-181" data-mp="nb6kflpmn9kz">Oral Rehabilitation Blueprint™</p>
            <p className="text-xs font-medium text-ink-muted" data-id="element-182" data-mp="3d2bidl8y6rtf">by Dr. Nathan Brooks</p>
          </div>
        </div>

        <h1 className="mt-7 font-serif text-[34px] font-extrabold leading-[1.08] text-navy sm:text-6xl" data-id="element-183" data-mp="3814aznapvuna">
          Organize Your Next Complex Oral Rehabilitation Case Into a Clear Treatment Roadmap{' '}
          <span className="italic text-gold" data-id="element-184" data-mp="3o6u5v6uu4lbc">in 15 Minutes</span>
        </h1>

        <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-ink-muted sm:text-xl" data-id="element-185" data-mp="399jo5frlmj76">
          Stop staring at a blank page. A practical, step-by-step framework to organize findings, define objectives, map
          priorities, document phases, and review your plan. Includes <strong className="text-navy" data-id="element-186" data-mp="358zr0c70zfl1">6 premium volumes</strong>,{' '}
          <strong className="text-navy" data-id="element-187" data-mp="2qjv96w457ddg">5 professional bonuses</strong> and{' '}
          <strong className="text-navy" data-id="element-188" data-mp="2qhqvjmgfyzzz">30+ protocols & checklists</strong>.
        </p>

        <div className="-mx-4 mt-6 w-[calc(100%+2rem)] sm:mx-0 sm:w-full sm:max-w-3xl" data-id="element-189" data-mp="2vj7rr4nzdya8">
          <img src={images.mainMockup} alt="Oral Rehabilitation Blueprint: 6 volumes, tablet frameworks and planning worksheets" className="h-auto w-full" data-id="element-190" data-mp="2hjowhcg9qhfc" />
        </div>

        <ul className="mt-2 grid w-full max-w-xl grid-cols-3 gap-2 text-navy" data-id="element-191" data-mp="s44gvk8yvfgb">
          {[{
          icon: BookOpenIcon,
          n: '6',
          l: 'Volumes'
        }, {
          icon: GiftIcon,
          n: '5',
          l: 'Bonuses'
        }, {
          icon: ListChecksIcon,
          n: '30+',
          l: 'Tools'
        }].map(s => <li key={s.l} className="flex flex-col items-center rounded-xl bg-white px-2 py-3 shadow-sm ring-1 ring-navy/5" data-id="element-192" data-mp="deyitzlv7va0">
              <s.icon aria-hidden="true" className="h-5 w-5 text-gold" data-id="element-193" data-mp="161t24t6y4olw" />
              <span className="mt-1 font-serif text-2xl font-extrabold" data-id="element-194" data-mp="162lyr1c6xxqb">{s.n}</span>
              <span className="text-xs font-semibold uppercase tracking-wide text-ink-muted" data-id="element-195" data-mp="11150zep06rdy">{s.l}</span>
            </li>)}
        </ul>

        <div className="mt-8 w-full" data-id="element-196" data-mp="3lsypyre788fd">
          <CtaButton id="first-cta" label="I Want Oral Rehabilitation Blueprint™" meta="Immediate digital access · One-time payment of USD $27 · Lifetime access · 7-Day Guarantee" data-id="element-197" data-mp="3lu081ftmtv6l" />
        </div>

        <div className="mt-8" data-id="element-198" data-mp="1x7hupaiwtwza">
          <Countdown data-id="element-199" data-mp="21aekpmas4vd9" />
        </div>

        <div className="mt-8 w-full max-w-xl rounded-2xl border-2 border-dashed border-gold bg-gold-pale px-5 py-5" data-id="element-200" data-mp="21bfu7mc5d9sv">
          <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-navy" data-id="element-201" data-mp="267wiqhn9dq6h">Limited introductory offer</p>
          <p className="mt-2 font-serif text-xl font-bold text-navy sm:text-2xl" data-id="element-202" data-mp="2b2k6geafugk0">
            Get the complete digital system today for just <span className="text-cta" data-id="element-203" data-mp="2kydrkm283ide">$27</span>.
          </p>
          <p className="mt-2 text-sm text-ink-muted" data-id="element-204" data-mp="2l0q9x0bw7uqz">Currency conversion is automatically calculated according to your country.</p>
        </div>
      </div>
    </header>;
}